import { useEffect } from 'react';
import { REDUX_APP_CLEAR_WEATHER_WARNING_TARGET } from 'redux-state/app/reducer.js';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';
import { getWindow } from 'utilities/window.js';

/** Checks if warningBannerTarget matches slug and clears target */
export const ManageUniqueWarningSlug = (slug: string) => {
  const appDispatch = useAppDispatch();
  const selectedItem = useAppSelector((s) => s.APP.weatherWarningTarget);
  const highlighted = selectedItem === slug;
  useEffect(() => {
    if (highlighted) {
      setTimeout(() => {
        appDispatch(REDUX_APP_CLEAR_WEATHER_WARNING_TARGET());
      }, 1000);
    }
  }, [highlighted, appDispatch]);
  return highlighted;
};

/**
 * @returns {number} yPosition of warning banner with sticky banners taken into account
 */
export const getWarningBannerTopOffset = () => {
  const lclWindow = getWindow();
  if (lclWindow) {
    const { document } = lclWindow;
    const weatherWarningBannerEl = document.querySelector('div.WeatherWarning-header');
    const stickyNavElNodeList = document.querySelectorAll<HTMLElement>('div.StickyNav');
    // As when selected the item may not be showing we cannot check if it is showing we must expect that it is showing
    const offsetHeight = Array.from(stickyNavElNodeList ?? []).reduce<number>((total, item) => {
      const additionalHeight = item ? item.offsetHeight : 0;
      return total + additionalHeight;
    }, 0);

    if (weatherWarningBannerEl) {
      // scroll to banner pos and add additional height of sticky nav bars
      const yPos = weatherWarningBannerEl.getBoundingClientRect().top + (getWindow()?.scrollY ?? 0);
      return yPos - offsetHeight;
    }
  }

  return 0;
};
